import { createFileRoute } from "@tanstack/react-router";
import { WorkPackagePage } from "../../../../features/work-package-estimation/work-package-estimation-page";

export const Route = createFileRoute("/_auth/_project/bid-row-details/$projectId/$subProjectId/work-packages")({
  component: WorkPackagePage,
});
